import { render } from "./TrustedCarriers.vue?vue&type=template&id=92a70010&scoped=true"
import script from "./TrustedCarriers.vue?vue&type=script&lang=js"
export * from "./TrustedCarriers.vue?vue&type=script&lang=js"

import "./TrustedCarriers.vue?vue&type=style&index=0&id=92a70010&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92a70010"]])

export default __exports__